<template>
  <div>
    <div class="md-layout md-gutter">
      <div class="md-layout-item md-size-50">
        <md-field :class="!checkArea(typeInfo.area) ? 'md-invalid' : ''">
          <label for="area">{{ $t("typeInfo.areaOther") }} (ha)</label>
          <md-input type="number" step="0.01" name="area" v-model="typeInfo.area" />
          <span class="md-error">{{ $t("error.errorRange") }} (0-99999)</span>
        </md-field>
      </div>
      <div class="md-layout-item md-size-50">
        <md-field>
          <select v-model="typeInfo.other_type" name="otherType">
            <option disabled value="">{{ $t("typeInfo.otherType") }}</option>
            <option v-for="(ot, key) in otherTypeList" :value="key" :key="key">{{ ot }}</option>
          </select>
        </md-field>
      </div>
      <div class="md-layout-item md-size-100">
        <toggle-buttons :btnList="frequencyList" :label="$t('typeInfo.frequency')" @btnValue="getFrequency" :editTB="typeInfo.frequency" />
      </div>
      <div class="md-layout-item md-size-100">
        <toggle-buttons :btnList="effectList" :label="$t('typeInfo.effect')" @btnValue="getEffect" :editTB="typeInfo.effect" />
      </div>
    </div>

    <error-dialog :show="error" :text="$t('error.dataCheck')" @closeError="error = false" />
  </div>
</template>

<script>
import ToggleButtons from '@/components/ToggleButtons'
import ErrorDialog from '@/components/ErrorDialog'

import EventBus from '@/event-bus'
import { getDomain } from '@/assets/scripts/domainsManager'
import { checkArea, normalize } from '@/assets/scripts/formatData'

const FREQUENCY = 'event_frequency'
const EFFECT = 'event_effect'
const OTHER_TYPE = 'other_event_type'

export default {
  name: 'Other',
  components: {
    ToggleButtons,
    ErrorDialog
  },
  data: () => ({
    typeInfo: {
      area: null,
      other_type: '',
      frequency: '',
      effect: ''
    },
    otherTypeList: {},
    frequencyList: {},
    effectList: {},
    edit: false,
    checkArea: checkArea,
    error: false
  }),
  mounted () {
    this.$store.state.plot.id === null ? this.edit = false : this.edit = true

    EventBus.$on('save', () => {
      this.saveData()
    })

    this.setLists()

    if (this.edit) {
      this.typeInfo = this.$store.state.plot.typeInfo // ref to store
    }
  },
  methods: {
    saveData: function () {
      if (this.checkData()) {
        if (this.typeInfo.area !== null) this.typeInfo.area = normalize(this.typeInfo.area, 2)
        this.edit ? this.$emit('typeInfo', null) : this.$emit('typeInfo', this.typeInfo)
      } else {
        this.error = true
      }
    },

    setLists: function () {
      getDomain(OTHER_TYPE).then(data => {
        this.otherTypeList = data[this.$i18n.locale]
      })
      getDomain(FREQUENCY).then(data => {
        this.frequencyList = data[this.$i18n.locale]
      })
      getDomain(EFFECT).then(data => {
        this.effectList = data[this.$i18n.locale]
      })
    },

    getFrequency: function (value) {
      this.typeInfo.frequency = value
    },

    getEffect: function (value) {
      this.typeInfo.effect = value
    },

    checkData: function () {
      return checkArea(this.typeInfo.area)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/arcadia_theme.scss';
</style>
